import React, { useState } from 'react';

import PrintAssetForm from '../../../apps/pro/views/AlbumFolder/AlbumFolders/AlbumFolderPictureDay/PrintAssetForm/PrintAssetForm';
import CustomControl from '../../../components/global/CustomControl';
import {
  PRINT_ASSET_TYPES,
  PRINT_ASSET_SOURCES,
} from '../../../constants/print-assets';
import { capitalize } from '../../../util/text';

const PrintAssetCreate = () => {
  const [printAssetType, setPrintAssetType] = useState(
    PRINT_ASSET_TYPES.BACKGROUND,
  );
  const [createdPrintAssets, setCreatedPrintAssets] = useState([]);

  return (
    <div className="p-4 mx-auto" style={{ maxWidth: '480px' }}>
      <h3>Print Asset Creator</h3>
      <p className="text-light">
        Creates account print assets through <code>printAssetCreate</code>,
        including SYSTEM-sourced ones for the Waldo library.
      </p>

      <div className="form-group">
        <div className="d-flex">
          {Object.values(PRINT_ASSET_TYPES).map(type => (
            <CustomControl
              key={type}
              id={`print-asset-type-${type}`}
              type="radio"
              name="printAssetType"
              className="mr-3"
              checked={printAssetType === type}
              onChange={() => setPrintAssetType(type)}
              label={capitalize(type.toLowerCase())}
            />
          ))}
        </div>
      </div>

      <PrintAssetForm
        key={`${printAssetType}-${createdPrintAssets.length}`}
        defaultPrintAssetType={printAssetType}
        showSourceControl
        defaultSource={PRINT_ASSET_SOURCES.SYSTEM}
        onPrintAssetCreate={printAsset =>
          setCreatedPrintAssets(prev => [printAsset, ...prev])
        }
      />

      {createdPrintAssets.length > 0 && (
        <div className="mt-4">
          <h4>Created this session</h4>
          {createdPrintAssets.map(printAsset => (
            <div key={printAsset.id} className="d-flex align-items-center mt-2">
              <img
                src={printAsset.asset_image.url}
                alt={printAsset.name}
                className="mr-2"
                style={{ width: '48px', height: '48px', objectFit: 'contain' }}
              />
              <span>
                <b>{printAsset.name}</b> &mdash; {printAsset.type} /{' '}
                {printAsset.source} (<code>{printAsset.id}</code>)
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PrintAssetCreate;
